import * as angular from 'angular';

import * as authenticationService from './authentication';
import * as currentUserService from './currentUser';
import * as hippoApiService from './hippoApi';
import * as loggingService from './logging';
import * as modalService from 'common/source/services/modal';
import * as navigationService from './navigation';
import * as clickTrackingService from './clickTracking';
import * as analyticsService from 'common/source/services/analytics';
import * as permissionService from './permission';
import * as experimentsService from './experiments';
import * as flagshipService from './flagship';

export const module = angular.module('customer-portal-services', [
    authenticationService.module.name,
    currentUserService.module.name,
    hippoApiService.module.name,
    loggingService.module.name,
    modalService.module.name,
    navigationService.module.name,
    clickTrackingService.module.name,
    analyticsService.module.name,
    permissionService.module.name,
    experimentsService.module.name,
    flagshipService.module.name
]);
